module.exports = __webpack_public_path__ + "media/images/design_pin_logo-b0a36d6f3f804994352adf2e500fc3d3.png";